<button mat-flat-button #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="viewsMenu">
  {{ selectedView()?.name }}

  <mat-icon iconPositionEnd [svgIcon]="menuTrigger.menuOpen | transform: getIconName"></mat-icon>
</button>

<mat-menu #viewsMenu="matMenu">
  <ng-container *ngIf="isRequirementsManager(); else switchToView">
    <button
      mat-menu-item
      *ngFor="let view of views()"
      q9Track="grid_views_manage_view"
      [matMenuTriggerFor]="actionsMenu"
      [matMenuTriggerData]="{view: view}"
      [class.active]="selectedView()?.id === view.id">
      {{ view.name }}
    </button>
  </ng-container>

  <ng-template #switchToView>
    <button
      mat-menu-item
      *ngFor="let view of views()"
      (click)="selectView(view.id)"
      [class.active]="selectedView()?.id === view.id">
      {{ view.name }}
    </button>
  </ng-template>

  <ng-container *ngIf="isRequirementsManager()">
    <mat-divider></mat-divider>
    <button mat-menu-item q9Track="GRID_VIEWS.CREATE_OPTION" (click)="create()">
      {{ 'GRID_VIEWS.CREATE_OPTION_TITLE' | translate }}
    </button>
  </ng-container>
</mat-menu>

<mat-menu #actionsMenu="matMenu">
  <ng-template matMenuContent let-view="view">
    <button mat-menu-item q9Track="GRID_VIEWS.SWITCH_OPTION" (click)="selectView(view.id)">
      {{ 'GRID_VIEWS.SWITCH_OPTION_TITLE' | translate }}
    </button>

    <ng-container *ngIf="isRequirementsManager()">
      <button
        mat-menu-item
        q9Track="GRID_VIEWS.EDIT_OPTION"
        *ngIf="!view.default"
        (click)="edit(view)">
        {{ 'GRID_VIEWS.EDIT_OPTION_TITLE' | translate }}
      </button>
      <button
        mat-menu-item
        q9Track="GRID_VIEWS.EDIT_FILTERS_OPTION"
        (click)="editFilters(view)"
        *ngIf="!view.default">
        {{ 'GRID_VIEWS.EDIT_FILTERS_OPTION_TITLE' | translate }}
      </button>
      <button mat-menu-item q9Track="GRID_VIEWS.CLONE_OPTION" (click)="create(view)">
        {{ 'GRID_VIEWS.CLONE_OPTION_TITLE' | translate }}
      </button>
      <ng-container *ngIf="!view.default">
        <span
          matTooltipPosition="below"
          [matTooltipDisabled]="view.id !== selectedView()?.id"
          [matTooltip]="'GRID_VIEWS.CANNOT_DELETE_SELECTED_VIEW_MSG' | translate">
          <button
            mat-menu-item
            (click)="delete(view)"
            q9Track="GRID_VIEWS.REMOVE_OPTION"
            [disabled]="view.id === selectedView()?.id">
            {{ 'GRID_VIEWS.REMOVE_OPTION_TITLE' | translate }}
          </button>
        </span>
      </ng-container>
    </ng-container>
  </ng-template>
</mat-menu>
